// Model-written prose (graders' evidence and analyses, the verifier's notes): Markdown, clamped to a few lines with
// a "Show more". Graders write their lists inline ("Gaps: - one. - two."), so those dashes start lines of their own.
import { renderMd } from '../core'

const LINES = 5

/** Inline list items ("…: - a. - b.") onto lines of their own, when there are at least two and no line breaks. */
export function listify(text: string): string {
  if (text.includes('\n') || (text.match(/[.:;] - \S/g) || []).length < 2) return text
  return text.replace(/([.:;]) - (?=\S)/g, '$1\n- ')
}

export function prose(text: unknown): string {
  const t = String(text ?? '').trim()
  if (!t) return ''
  return '<div class="rp-clamp" style="--rp-lines:' + LINES + '"><div class="rp-clamp-b">' + renderMd(listify(t)) + '</div>' +
    '<button type="button" class="rp-more" hidden>Show more</button></div>'
}

/** Show "Show more" only where the text runs past its lines; it toggles the whole text. */
export function wireProse(root: HTMLElement): void {
  Array.prototype.forEach.call(root.querySelectorAll('.rp-clamp'), (box: HTMLElement) => {
    const body = box.querySelector('.rp-clamp-b') as HTMLElement
    const more = box.querySelector('.rp-more') as HTMLButtonElement
    if (!body || !more || box.classList.contains('open')) return
    const over = body.scrollHeight > body.clientHeight + 2
    more.hidden = !over
    body.classList.toggle('over', over)
    more.onclick = () => {
      const open = box.classList.toggle('open')
      more.textContent = open ? 'Show less' : 'Show more'
    }
  })
}
